export enum ELegalLinks {
  TERMS_OF_USE = 'https://www.spoton.com/legal/user-terms',
  PRIVACY_POLICY = 'https://www.spoton.com/legal/consumer-privacy',
  ACCESSIBILITY_STATEMENT = 'https://www.spoton.com/legal/accessibility-statement',
  RECAPTCHA_PRIVACY_POLICY = 'https://policies.google.com/privacy',
  RECAPTCHA_TERMS_OF_SERVICE = 'https://policies.google.com/terms',
}
